(() => {
  if (customElements.get('lisa-thermal-offer')) return;
  const source = document.getElementById('LisaThermalOfferConfig');
  if (!source) return;
  const config = JSON.parse(source.textContent);
  const ids = Object.fromEntries(Object.entries(config.groups).map(([key, values]) => [key, new Set(values.map(String))]));
  const labels = config.labels;
  const instances = new Set();
  let cart = null, request = null, timer;
  const replace = (text, count) => text.replace('__COUNT__', count);
  const countText = (count, group) => {
    const text = config.groupLabels?.[group] || labels;
    return count === 1 ? text.countOne : replace(text.count, count);
  };
  const eligible = (group, item) => ids[group]?.has(String(item.variant_id || item.id));
  async function refreshCart() {
    if (!instances.size) return;
    if (request) { request.then(() => schedule()); return request; }
    request = (async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}});
        if (!response.ok) throw new Error('cart');
        cart = await response.json();
        instances.forEach(panel => { panel.failed = false; panel.render(); });
      } catch {
        instances.forEach(panel => { panel.failed = true; panel.render(); });
      } finally { request = null; }
    })();
    return request;
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refreshCart, 180); }
  class ThermalOffer extends HTMLElement {
    connectedCallback() {
      if (!ids[this.dataset.group]) return;
      instances.add(this);
      this.onInput = () => this.render();
      const picker = this.closest('lisa-thermal-picker');
      const selector = picker?.querySelector('select');
      this.formId = selector?.getAttribute('form');
      this.bound = this.closest('.product__info-container') || picker;
      this.bound?.addEventListener('input', this.onInput);
      this.bound?.addEventListener('change', this.onInput);
      this.render();
      schedule();
    }
    disconnectedCallback() {
      instances.delete(this);
      this.bound?.removeEventListener('input', this.onInput);
      this.bound?.removeEventListener('change', this.onInput);
    }
    render() {
      const group = this.dataset.group;
      const lines = (cart?.items || []).filter(item => eligible(group, item));
      const count = cart ? lines.reduce((sum, item) => sum + item.quantity, 0) : Number(this.dataset.count || 0);
      this.hidden = this.dataset.context === 'cart' && count === 0;
      this.querySelector('[data-thermal-count]').textContent = countText(count, group);
      this.querySelector('progress').value = Math.min(count, 12);
      const saving = lines.reduce((sum, item) => sum + (item.line_level_discount_allocations || []).reduce((total, allocation) => total + ((allocation.discount_application?.title || '').startsWith('Thermal wholesale') ? allocation.amount : 0), 0), 0);
      const unlocked = count >= 12 && saving > 0;
      this.classList.toggle('thermal-offer--unlocked', unlocked);
      const countLabel = this.querySelector('[data-thermal-count]');
      if (this.failed) countLabel.textContent = labels.error;
      else if (unlocked) countLabel.textContent = `${countText(count, group)} · ${labels.unlocked}`;
    }
  }
  customElements.define('lisa-thermal-offer', ThermalOffer);
  if ('PerformanceObserver' in window) {
    const observer = new PerformanceObserver(list => {
      if (list.getEntries().some(entry => {
        try { return /\/cart\/(add|change|update|clear)(\.js)?$/.test(new URL(entry.name).pathname); }
        catch { return false; }
      })) schedule();
    });
    observer.observe({type:'resource', buffered:false});
  }
  window.addEventListener('pageshow', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  document.addEventListener('cart:updated', schedule);
})();

